module.exports = __webpack_public_path__ + "img/zara_logo@2x.a7483c78.png";